// Modules
import { useHistory } from 'react-router-dom';
import { useContext, useEffect, ReactElement } from 'react';

// Components
import { FilterRowWrapper } from '../../../common/components';

// Context
import { MeterUpgradeProcessContext } from '../meterUpradeProcess/meterUpgradeProcessContext';
import { UserDetailContext, UserDetailContextProps } from '../../../context/userDetail/userDetailContext';

// Styles
import { MeterUpgradeWrapper, BlockWrapper, ReviewInfoRow } from './MeterUpgradeContactDetails.styles';

type MeterUpgradeConfirmationProps = {
  stepsBar: ReactElement;
  pageTitle: ReactElement;
};

export const MeterUpgradeConfirmation = ({ stepsBar, pageTitle }: MeterUpgradeConfirmationProps) => {
  const { userDetail } = useContext<UserDetailContextProps>(UserDetailContext);
  const history = useHistory();
  const { selectedSites, filledSitesData } = useContext<any>(MeterUpgradeProcessContext);

  useEffect(() => {
    // Navigate to 1st process step in case page reload
    if (!selectedSites?.length) {
      history.push('/home/meter-upgrade');
    }
    // TODO:  Might want to remove this and revisit this problem later
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSites]);

  return (
    <>
      <MeterUpgradeWrapper>
        <FilterRowWrapper>{pageTitle}</FilterRowWrapper>

        {selectedSites?.length && <div className='selectedAccountDisplay'>{`Acc - ${userDetail.essCustomerId}`}</div>}

        <div className='navigationBar'>{stepsBar}</div>

        <BlockWrapper>
          {selectedSites?.length && (
            <h4>{`Thanks for the information regarding meter upgrades for ${userDetail.essCustomerId}`}</h4>
          )}
          <ReviewInfoRow>
            <p>
              Our Metering team will contact the specified contact shortly to book an appointment at a suitable time for
              the meter upgrade to take place.
            </p>
            <p>If you have any questions, contact us on 01473 237848.</p>
          </ReviewInfoRow>
        </BlockWrapper>
      </MeterUpgradeWrapper>
    </>
  );
};
